module.exports = __webpack_public_path__ + "img/error.8865011e.svg";